import React from 'react';
import { BookOpen } from 'lucide-react';
import HelpIconButton from '../HelpIconButton';

// Read-only context screen. Three subsections (Intent, Audience, Scope
// Boundaries) explain why the Trust Portal exists. No interactive
// elements aside from the help icon.

const PurposeAndContext: React.FC = () => {
  return (
    <div className="space-y-6">
      <div className="flex items-start justify-between">
        <div className="flex items-center gap-3">
          <div className="p-2.5 bg-indigo-100 rounded-lg">
            <BookOpen className="w-6 h-6 text-indigo-700" />
          </div>
          <div>
            <h1 className="text-2xl font-bold text-gray-900">Purpose and Context</h1>
            <p className="text-sm text-gray-500 mt-0.5">
              Why this portal exists and who it is intended for.
            </p>
          </div>
        </div>
        <HelpIconButton screenId="purpose-and-context" showLabel />
      </div>

      {/* Body — placeholder prose until Ryan's handoff doc arrives. */}
      <div className="prose prose-sm max-w-none text-gray-700">
        <section className="p-5 bg-white border border-gray-200 rounded-xl">
          <h2 className="text-base font-semibold text-gray-900 !mt-0">Intent</h2>
          <p className="mt-2 leading-relaxed">
            The Jarvis Trust Portal exists to give security reviewers a single, current
            source of truth for TSG&apos;s security posture and the sub-provider chain that
            powers the Jarvis platform. Rather than shipping a static PDF or relying on
            scattered email attachments, the portal surfaces live information drawn from
            the same Vendor Management and compliance systems used internally by the TSG
            risk team.
          </p>
        </section>

        <section className="p-5 bg-white border border-gray-200 rounded-xl mt-4">
          <h2 className="text-base font-semibold text-gray-900 !mt-0">Audience</h2>
          <p className="mt-2 leading-relaxed">
            Three primary audiences are served by this portal:
          </p>
          <ul className="mt-2 space-y-1.5 list-disc pl-5">
            <li>
              <strong>Client security reviewers</strong> — performing pre-engagement due
              diligence on TSG as a vendor.
            </li>
            <li>
              <strong>Third-party risk managers</strong> — running ongoing risk assessment
              cycles on TSG or on sub-providers they inherit via TSG.
            </li>
            <li>
              <strong>New TSG consultants</strong> — orienting themselves to the vendor
              chain and compliance landscape during onboarding.
            </li>
          </ul>
        </section>

        <section className="p-5 bg-white border border-gray-200 rounded-xl mt-4">
          <h2 className="text-base font-semibold text-gray-900 !mt-0">Scope Boundaries</h2>
          <p className="mt-2 leading-relaxed">
            The Trust Portal is deliberately <em>not</em> the right place for
            client-specific RCSA findings, engagement-level deliverables, or confidential
            audit artifacts. Those belong in the respective engagement workspaces. If you
            are looking for engagement data, please reach out to your TSG point of contact
            directly.
          </p>
        </section>
      </div>

      <div className="p-4 bg-gray-50 border border-gray-200 rounded-lg text-xs text-gray-500">
        Placeholder content — will be replaced with approved text from
        <span className="font-mono mx-1">jarvis-trust-portal-help-text.docx</span>
        when it lands.
      </div>
    </div>
  );
};

export default PurposeAndContext;
